var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoneBenefit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3998 5.59999C11.9998 5.19999 11.3998 5.19999 10.9998 5.59999L6.9998 9.59999L4.9998 7.59999C4.5998 7.19999 3.9998 7.19999 3.5998 7.59999C3.1998 7.99999 3.1998 8.59999 3.5998 8.99999L6.2998 11.7C6.4998 11.9 6.6998 12 6.9998 12C7.2998 12 7.4998 11.9 7.6998 11.7L12.3998 6.99999C12.7998 6.59999 12.7998 5.99999 12.3998 5.59999Z",
  fill: "#FF9E00"
})));
export { SvgDoneBenefit as ReactComponent };